/* eslint-disable no-console */
import { register } from 'register-service-worker'

const isProduction = process.env.NODE_ENV === 'production'

const queryUrl = window.location.search
const isDisableFirebase = queryUrl?.includes('disable-firebase')

/** 👇 firebase disable for mobile flutter web view */
// if (isProduction && !isDisableFirebase) {

const firebaseJs = `${process.env.BASE_URL}firebase-messaging-sw.js`

const PassingData = ({ event, data }) => {
  const config = { userVisibleOnly: true }
  const stringifyData = JSON.stringify(data)

  console.log('===> [SERVICE WORKER: PassingData]', {
    config,
    event,
    data,
    stringifyData,
  })

  // event.pushManager.subscribe(config).then((params) => {
  //   console.log('===> [SERVICE WORKER: PassingData subscribe]', params)
  // })
  event.active.postMessage(stringifyData)
}

const init = (data) => register(firebaseJs, {
  ready (event) {
    // https://stackoverflow.com/questions/40887635/access-localstorage-from-service-worker
    console.log('===> [SERVICE WORKER: ready] App is being served from cache by a service worker.\n', event)
    PassingData({ event, data })
  },
  registered (event) {
    console.log('===> [SERVICE WORKER: registered] Has been registered.', event)
  },
  cached (event) {
    console.log('===> [SERVICE WORKER: cached] Content has been cached for offline use.', event)
  },
  updatefound (event) {
    console.log('===> [SERVICE WORKER: updatefound] New content is downloading.', event)
  },
  updated (event) {
    console.log('===> [SERVICE WORKER: updated] New content is available; please refresh.', event)
  },
  offline (event) {
    console.log(
      '===> [SERVICE WORKER: offline] No internet connection found. App is running in offline mode.',
      event
    )
  },
  error (error) {
    console.error('===> [SERVICE WORKER: error] Error during service worker registration:', error)
  }
})

const emptyFunc = () => {}

const ServiceWorker = {
  register: isDisableFirebase ? emptyFunc : init
}

export default ServiceWorker;
